<template>
    <div class="svg-container-outer">
        <LoadingData v-if="loadingDespatch" :headerMessage="'Loading Optimisation'"/>
        <div class="route-info">
            <div v-if="(selectedTripSheetID != '') && (manifestMapData.length > 0)" class="route-info-inner">
                <h3 class="manifest-header">Master Manifest</h3>
            </div>
        </div>
        <div v-if="(selectedTripSheetID != '') && (manifestMapData.length > 0)"  class="svg-container">
            <div class="svg-inner-container">
                <p>Awaiting Service</p>
                <svg xmlns="http://www.w3.org/2000/svg" overflow="visible" width="15" height="25" viewBox="0 0 24 32">
                    <g transform="translate(1.75, 28.0)" fill="#000000"><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="10.5" ry="5.25002273"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="10.5" ry="5.25002273"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="9.5" ry="4.77275007"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="8.5" ry="4.29549936"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="7.5" ry="3.81822308"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="6.5" ry="3.34094679"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="5.5" ry="2.86367051"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="4.5" ry="2.38636864"></ellipse></g>
                    <path stroke="#000" stroke-width="1" fill="#32ccfe" d="M12,0c-6.6,0-12,5.4-12,12c0,10,12,20,12,20s12-10,12-20C24,5.4,18.6,0,12,0z M12,15c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S13.7,15,12,15z"/>
                    <circle cx="12" cy="12" r="10.5" fill="#32ccfe"/>
                    <text x="50%" y="45%" text-anchor="middle" fill="#FFFFFF" font-size="12" dy=".3em" font-weight = "bold">1</text>
                </svg>
            </div>
            <div class="svg-inner-container">
                <p>Service Completed</p>
                <svg xmlns="http://www.w3.org/2000/svg" overflow="visible" width="15" height="25" viewBox="0 0 24 32">
                    <g transform="translate(1.75, 28.0)" fill="#000000"><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="10.5" ry="5.25002273"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="10.5" ry="5.25002273"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="9.5" ry="4.77275007"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="8.5" ry="4.29549936"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="7.5" ry="3.81822308"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="6.5" ry="3.34094679"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="5.5" ry="2.86367051"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="4.5" ry="2.38636864"></ellipse></g>
                    <path stroke="#000" stroke-width="1" fill="#33f18a" d="M12,0c-6.6,0-12,5.4-12,12c0,10,12,20,12,20s12-10,12-20C24,5.4,18.6,0,12,0z M12,15c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S13.7,15,12,15z"/>
                    <circle cx="12" cy="12" r="10.5" fill="#33f18a"/>
                    <text x="50%" y="45%" text-anchor="middle" fill="#FFFFFF" font-size="12" dy=".3em" font-weight = "bold">2</text>
                </svg>
            </div>
            <div class="svg-inner-container">
                <p>Service Incomplete</p>
                <svg xmlns="http://www.w3.org/2000/svg" overflow="visible" width="15" height="25" viewBox="0 0 24 32">
                    <g transform="translate(1.75, 28.0)" fill="#000000"><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="10.5" ry="5.25002273"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="10.5" ry="5.25002273"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="9.5" ry="4.77275007"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="8.5" ry="4.29549936"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="7.5" ry="3.81822308"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="6.5" ry="3.34094679"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="5.5" ry="2.86367051"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="4.5" ry="2.38636864"></ellipse></g>
                    <path stroke="#000" stroke-width="1" fill="#fe804d" d="M12,0c-6.6,0-12,5.4-12,12c0,10,12,20,12,20s12-10,12-20C24,5.4,18.6,0,12,0z M12,15c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S13.7,15,12,15z"/>
                    <circle cx="12" cy="12" r="10.5" fill="#fe804d"/>
                    <text x="50%" y="45%" text-anchor="middle" fill="#FFFFFF" font-size="12" dy=".3em" font-weight = "bold">3</text>
                </svg>
            </div>
            <div class="svg-inner-container">
                <p>Service In Progress</p>
                <svg xmlns="http://www.w3.org/2000/svg" overflow="visible" width="15" height="25" viewBox="0 0 24 32">
                    <g transform="translate(1.75, 28.0)" fill="#000000"><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="10.5" ry="5.25002273"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="10.5" ry="5.25002273"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="9.5" ry="4.77275007"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="8.5" ry="4.29549936"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="7.5" ry="3.81822308"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="6.5" ry="3.34094679"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="5.5" ry="2.86367051"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="4.5" ry="2.38636864"></ellipse></g>
                    <path stroke="#000" stroke-width="1" fill="#fee354" d="M12,0c-6.6,0-12,5.4-12,12c0,10,12,20,12,20s12-10,12-20C24,5.4,18.6,0,12,0z M12,15c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S13.7,15,12,15z"/>
                    <circle cx="12" cy="12" r="10.5" fill="#fee354"/>
                    <text x="50%" y="45%" text-anchor="middle" fill="#FFFFFF" font-size="12" dy=".3em" font-weight = "bold">4</text>
                </svg>
            </div>
        </div>
        <div v-if="(selectedTripSheetID != '') && (manifestMapData.length > 0) && (manifestedSuccessfully == false)" class="button-container">
            <button class="refresh-button" @click="refreshMap()">Refresh</button>
        </div>
    </div>
  <div v-if="(selectedTripSheetID != '') && (manifestMapData.length > 0)" ref="awsmap" id="map" />
  <loading-skeleton :loadingHeight="'50vh'" v-if="loadingManifestData"/>

  <shipment-info v-if="toggleTrackShipment" @closeShipmentInfo="closeShipmentInfo($event)" :cognitoUser="user" :trackShipmentID="popUpSelectedShipmentID"/>

  <div v-if="showDragAddressSuggestion" class="alert-container">
      <div class="inner-container">
          <div class="text-container">
            <div class="header-outer-container">
                <div class="header-container">
                    <svg style="width: 15px;
                    height: 15px;
                    padding-right: 5px;" id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 251.67 328.54" data-v-13454f0d=""><g id="_Ñëîé_1" data-name="Ñëîé 1" data-v-13454f0d=""><g data-v-13454f0d=""><g data-v-13454f0d=""><polyline class="cls-2-alt" points="213.95 310.25 213.95 280.72 192.99 240.34 66.07 240.34 45.11 284.23 45.11 310.25" data-v-13454f0d=""></polyline><line class="cls-2-alt" x1="48.63" y1="284.23" x2="213.95" y2="284.23" data-v-13454f0d=""></line><polyline class="cls-2-alt" points="150.64 284.23 150.64 323.54 129.53 314.13 108.43 323.54 108.43 284.23" data-v-13454f0d=""></polyline><line class="cls-2-alt" x1="115.46" y1="240.34" x2="108.43" y2="284.23" data-v-13454f0d=""></line><line class="cls-2-alt" x1="150.64" y1="284.23" x2="143.6" y2="240.34" data-v-13454f0d=""></line></g><path class="cls-2" d="M5,263.23l4.07-31.12c1.49-11.39,9.48-20.87,20.45-24.26l41.72-12.89c4.68-1.45,9.78-.46,13.58,2.62h0c23.9,19.38,58.11,19.38,82.01,0h0c3.81-3.09,8.9-4.07,13.58-2.62l41.72,12.89c10.97,3.39,18.97,12.87,20.45,24.26l4.07,31.12" data-v-13454f0d=""></path><path class="cls-2" d="M179.67,133.69v1.49c0,17.17-9.99,32.77-25.58,39.95l-16.31,7.52c-7.79,3.59-16.76,3.59-24.54,0l-16.31-7.52c-15.59-7.18-25.58-22.78-25.58-39.95v-1.49" data-v-13454f0d=""></path><path class="cls-2" d="M66.66,77.38l2.08-34.12c.68-11.22,7.8-21.02,18.25-25.15l28.02-11.08c6.83-2.7,14.44-2.7,21.28,0l28.02,11.08c10.45,4.13,17.56,13.94,18.25,25.15l2.08,34.12" data-v-13454f0d=""></path><path class="cls-2" d="M182.17,75.94l-.69-.59c-31.61-27.16-78.16-27.68-110.37-1.23l-1.41,1.16c-5.33,4.37-6.62,12-3.03,17.89l8.7,14.27h0c30.19-23.72,72.69-23.72,102.89,0h0s3.95-8.06,7.32-14.94c2.77-5.66,1.38-12.46-3.4-16.56Z" data-v-13454f0d=""></path><path class="cls-2" d="M57.76,116.69l-.15,.9c-1.37,8.44,5.15,16.11,13.7,16.11h.03" data-v-13454f0d=""></path><path class="cls-2" d="M193.24,116.69l.15,.9c1.37,8.44-5.15,16.11-13.7,16.11h0" data-v-13454f0d=""></path></g></g></svg>
                    <h3 style="margin: 0">{{popUpSelectedShipmentID}}</h3>
                </div>  
            </div>
            
            <p>{{autoCompleteData[0].Place.Label}}</p>
            <button class="cancel-button" @click="closeAddressSuggestion()">Cancel</button>
          </div>
      </div>
  </div>
  <AlertUser v-if="toggleAlertBox" @closeAlertBox="closeAlertBox($event)" :message="alertMessage"/> 
</template>

<script>
import { Auth, Signer, API } from 'aws-amplify'
import Location from "aws-sdk/clients/location";
import maplibregl from 'maplibre-gl'
import AWS from '../../aws-exports'
import 'maplibre-gl/dist/maplibre-gl.css';
import ShipmentInfo from '../ShipmentDashboard/ShipmentInfo.vue'
import LoadingSkeleton from '../ShipmentDashboard/LoadingSkeleton.vue'
import AlertUser from '../Popups/AlertUser.vue';
import LoadingData from '../../components/Popups/LoadingData.vue';

export default {
    data(){
        return{
            toggleTrackShipment: false,
            manifestTripSheetID: null,
            manifestedSuccessfully: false,
            showDragAddressSuggestion: false,
            loadingDespatch: false,
            newLatitude: "",
            newLongitude: "",
            autoCompleteData: [],
            credentials: null,
            user: {},
            mapCenter: [],
            popUpSelectedShipmentID: "",
            manifestMapData: [],
            selectedRoute: "",
            toggleAlertBox: false,
            alertMessage: "",
            loadingManifestData: false,
            routeTableData: [],
            selectedRouteObject: {},
            toggleWaypointTable: true
        }
    },
    components:{
        ShipmentInfo,
        LoadingSkeleton,
        AlertUser,
        LoadingData
    },
    watch:{
        async 'selectedTripSheetID'(){
            await this.getManifestShipmentData()
            if(this.manifestMapData.length > 0){
                    this.mapCreate();
            }else{
                this.toggleAlertBox = true;
                this.alertMessage = "No manifest data available";
                this.selectedRoute = "";
            }
        }
    },
    props:['showPickupLogic', 'routeData', 'userData', 'selectedTripSheetID'],
    mounted: async function () {
        this.credentials = await Auth.currentCredentials()

        Auth.currentAuthenticatedUser().then(user => {
            this.user = user;
            this.listRouteData();
        }).catch(error => {
          if(error){
            this.$router.push('Login');
            Auth.signOut({global: false})
          }
        });
        await this.getManifestShipmentData()
        if(this.manifestMapData.length > 0){
                this.mapCreate();
        }else{
            this.toggleAlertBox = true;
            this.alertMessage = "No manifest data available";
            this.selectedRoute = "";
        }

        // setInterval(() => {
        //     this.refreshMap();
        // }, 30000);
    },
    unmounted(){
        //Reset hash allow map to adjust to address changes
        window.location.hash = ""
    },
    methods:{
        async reOpenManifest(){

            let updateRouteTable = `mutation updateRoute{
            updateRoute(input: {routeCode: "${this.selectedRoute}", manifestStatus: "Despatched"}) {
                    routeCode
                    openManifestAction
                    routeId
                    manifestCutoffTime
                }
            }
            `

            try{
                let updateRouteTableData = await API.graphql({
                query:  updateRouteTable,
                authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                console.log("Route Data: ", updateRouteTableData.data);
                this.toggleAlertBox = true;
                this.alertMessage = "Route status updated"
                this.$emit('toggleOpenManifestMap', {showOpenManifest: true})
            }catch(e){
                console.log(e)
                if(e){
                    this.toggleAlertBox = true;
                    this.alertMessage = "Error getting route data"
                }
            }
        },
        async getRouteData(){
            let input = {
                input:{
                    routeCode: this.selectedRoute
                }
            }
            let queryRouteTable = `query getRoute{
            getRoute(routeCode: "${this.selectedRoute}") {
                    routeCode
                    openManifestAction
                    routeId
                    manifestCutoffTime
                }
            }
            `

            try{
                let queryRouteTableData = await API.graphql({
                query:  queryRouteTable,
                variables: input,
                authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                console.log("Route Data: ", queryRouteTableData.data.getRoute);
                this.selectedRouteObject = queryRouteTableData.data.getRoute;
            }catch(e){
                console.log(e)
                if(e){
                    this.toggleAlertBox = true;
                    this.alertMessage = "Error getting route data"
                }
            }
        },
        async manifestCreateTripFunc(){
            let manifestsToDespatchValue = "Open";
            this.loadingDespatch = true;

            let input = {
                input:{
                    routeId: this.selectedRouteObject.routeId,
                    manifestsToDespatch: [manifestsToDespatchValue]
                }
            }
            let manifestCreateTrip = `mutation manifestCreateTrip{
            manifestCreateTrip(input: {routeId: ${this.selectedRouteObject.routeId}, manifestsToDespatch: ["${manifestsToDespatchValue}"]}) {
                    tripSheetID
                }
            }
            `

            try{
                let manifestCreateTripData = await API.graphql({
                query:  manifestCreateTrip,
                variables: input,
                authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                console.log("manifestCreateTrip Data: ", manifestCreateTripData.data.manifestCreateTrip.tripSheetID);
                this.loadingDespatch = false;
                this.manifestTripSheetID = manifestCreateTripData.data.manifestCreateTrip.tripSheetID;
                this.manifestedSuccessfully = true;
                return manifestCreateTripData.data.manifestCreateTrip.tripSheetID;
            }catch(e){
                console.log(e)
                if(e){
                    this.toggleAlertBox = true;
                    this.alertMessage = "Error getting manifestCreateTrip data"
                }
                this.loadingDespatch = false;
                this.manifestedSuccessfully = false;
                throw new Error("Manifest Create Trip Failed: ", e)
            }
        },
        async refreshMap(){
            await this.getManifestShipmentData()
            if(this.manifestMapData.length > 0){
                    this.mapCreate();
            }else{
                this.toggleAlertBox = true;
                this.alertMessage = "No manifest data available";
                this.selectedRoute = "";
            }
        },
        async selectRouteCode(event){
            this.manifestedSuccessfully = false;
            this.manifestTripSheetID = null;
            this.selectedRoute = "";
            this.isoDateTime = "";
            this.manifestMapData = []
            console.log(event)
            this.selectedRoute = event.routeCode;
        },
        closeAlertBox(toggleAlertBox){
            this.toggleAlertBox = toggleAlertBox;
        },
        trackShipment(){
            this.toggleTrackShipment = true;
        },
        closeShipmentInfo(){
            this.toggleTrackShipment = false;
        },
        closeAddressSuggestion(){
            this.showDragAddressSuggestion = false;
        },
        async getManifestShipmentData() {
            this.toggleWaypointTable = false;
            this.loadingManifestData = true;
            this.manifestMapData = []
            let graphqlQuery = `query listTripWaypoints($nextToken: String) {
                listTripWaypoints(nextToken: $nextToken) {
                    items{
                        tripSheetID
                        stop
                        longitude
                        latitude
                        route
                        geometry
                        waypoint
                        arrival
                        departure
                        stopType
                        isDelivery
                        windowEnd
                        windowStart
                        serviceIncomplete
                        serviceInProgress
                        serviceCompleted
                        shipments{
                        shipmentID
                            address{
                                address1
                                address2
                                latitude
                                longitude
                                city
                                companyName
                                zipCode
                                state
                            }
                        shipmentID
                        isPriority
                        signatureRequired
                        lastActivity{
                            activityTime
                            description
                            code
                            }
                        }
                    }
                    nextToken
                }
            }`;

            console.log(graphqlQuery)

            try {
                let allTripShipments = [];
                let nextToken = null;

                do {
                    let response = await API.graphql({
                        query: graphqlQuery,
                        authMode: "AMAZON_COGNITO_USER_POOLS",
                        variables: { nextToken }
                    });

                    const data = response.data.listTripWaypoints;
                    allTripShipments = [...allTripShipments, ...data.items];
                    nextToken = data.nextToken;

                } while (nextToken); 
                this.manifestMapData = [];
                this.manifestMapData = allTripShipments;
                console.log(this.manifestMapData.length)
                this.toggleWaypointTable = true;
                this.loadingManifestData = false;
            } catch (e) {
                console.log(e)
                this.toggleAlertBox = true;
                this.alertMessage = "Error getting waypoint data"
                this.loadingManifestData = false;
            }
        },
        async getLocationData(lng, lat){
            const credentials = await Auth.currentCredentials();

            const locationClient = new Location({
                credentials,
                region: 'us-east-1'
            });

            const params = {
                IndexName: "lrex-place",
                Position: [lng, lat],
                MaxResults: 5
            };

                locationClient.searchPlaceIndexForPosition(params,(err,data)=>{
                    if(err){
                        alert("Error with Location Services.")
                    }
                    if(data){
                        //Only suggest addresses with Street and AddressNumber Values
                        if(data.Results[0]){
                            if(data.Results[0].Place.AddressNumber || data.Results[0].Place.Street){
                                this.autoCompleteData = data.Results;
                                this.showDragAddressSuggestion = true;
                                console.log("Address from lat long: ", this.autoCompleteData[0].Place)
                            }
                        }
                    }
                })
        },
        mapCreate: function() {
                let mapCenter = null;
                let geometry = [];
         
                for (const location of this.manifestMapData) {
                    console.log("Inside for loop")
                    if (location.latitude !== null && location.longitude !== null) {
                        mapCenter = [location.longitude, location.latitude];
                    }

                    if (location.waypoint === "*" && location.geometry) {
                        // If this item has multiple lines: [ [[lng,lat],...], [[lng,lat],...] ]
                        if (Array.isArray(location.geometry[0]) && Array.isArray(location.geometry[0][0])) {
                        geometry.push(...location.geometry);
                        } else {
                        // Single line: [[lng,lat], ...]
                        geometry.push(location.geometry);
                        }
                    }
                }

                const map = new maplibregl.Map({
                    container: 'map',
                    style: 'LREXSite-Map',
                    center: mapCenter,
                    zoom: 10,
                    bearing: 64.8,
                    pitch: 10,
                    hash: true,
                    transformRequest: this.transformRequest
                });

                map.on('load', ()=>{
                    for (let i = 0; i < geometry.length; i++) {
                        const element = geometry[i];
                        console.log(element)
                        map.addSource('routeline' + i, {
                    type: 'geojson',
                    data: {
                        type: 'Feature',
                        properties: {},
                        geometry: {
                            type: 'LineString',
                            coordinates: element
                        }
                    }
                        })

                        map.addLayer({
                            id: 'routeline' + i,
                            type: 'line',
                            source: 'routeline' + i,
                            layout: {
                'line-join': 'round',
                'line-cap': 'round'
            },
            paint: {
                'line-color': '#000',
                'line-width': 4
            }
                        });
                }
                    }
                    )


                let markerArray = [];
                // markerArray.push(stopRecord)
                for (let i = 0; i < this.manifestMapData.length; i++) {
                    const element = this.manifestMapData[i];
                    let shipmentInfo = '';
                    element.shipments?.forEach((shipment) => {
                        shipmentInfo += `<h3 style="margin: 0;">Shipment ID: ${shipment.shipmentID}</h3>`;
                        shipmentInfo += `<p style="margin: 0;">Address: ${shipment.address.address1}, ${shipment.address.city}, ${shipment.address.state}, ${shipment.address.zipCode}</p>`;
                    })
                    const popup = new maplibregl.Popup({
                            offset: 15,
                    }).setHTML(
                            `
                            <div style="display: flex;
                            flex-direction: row;
                            align-items: center;
                            background-color: #e4e4e4;
                            border-radius: 999px;
                            padding: 5px;
                            width: -moz-fit-content;
                            width: fit-content;
                            margin-bottom: 5px;">
                            <svg style="width: 15px;
                            height: 15px;
                            padding-right: 5px;" id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 251.67 328.54" data-v-13454f0d=""><g id="_Ñëîé_1" data-name="Ñëîé 1" data-v-13454f0d=""><g data-v-13454f0d=""><g data-v-13454f0d=""><polyline class="cls-2-alt" points="213.95 310.25 213.95 280.72 192.99 240.34 66.07 240.34 45.11 284.23 45.11 310.25" data-v-13454f0d=""></polyline><line class="cls-2-alt" x1="48.63" y1="284.23" x2="213.95" y2="284.23" data-v-13454f0d=""></line><polyline class="cls-2-alt" points="150.64 284.23 150.64 323.54 129.53 314.13 108.43 323.54 108.43 284.23" data-v-13454f0d=""></polyline><line class="cls-2-alt" x1="115.46" y1="240.34" x2="108.43" y2="284.23" data-v-13454f0d=""></line><line class="cls-2-alt" x1="150.64" y1="284.23" x2="143.6" y2="240.34" data-v-13454f0d=""></line></g><path class="cls-2" d="M5,263.23l4.07-31.12c1.49-11.39,9.48-20.87,20.45-24.26l41.72-12.89c4.68-1.45,9.78-.46,13.58,2.62h0c23.9,19.38,58.11,19.38,82.01,0h0c3.81-3.09,8.9-4.07,13.58-2.62l41.72,12.89c10.97,3.39,18.97,12.87,20.45,24.26l4.07,31.12" data-v-13454f0d=""></path><path class="cls-2" d="M179.67,133.69v1.49c0,17.17-9.99,32.77-25.58,39.95l-16.31,7.52c-7.79,3.59-16.76,3.59-24.54,0l-16.31-7.52c-15.59-7.18-25.58-22.78-25.58-39.95v-1.49" data-v-13454f0d=""></path><path class="cls-2" d="M66.66,77.38l2.08-34.12c.68-11.22,7.8-21.02,18.25-25.15l28.02-11.08c6.83-2.7,14.44-2.7,21.28,0l28.02,11.08c10.45,4.13,17.56,13.94,18.25,25.15l2.08,34.12" data-v-13454f0d=""></path><path class="cls-2" d="M182.17,75.94l-.69-.59c-31.61-27.16-78.16-27.68-110.37-1.23l-1.41,1.16c-5.33,4.37-6.62,12-3.03,17.89l8.7,14.27h0c30.19-23.72,72.69-23.72,102.89,0h0s3.95-8.06,7.32-14.94c2.77-5.66,1.38-12.46-3.4-16.56Z" data-v-13454f0d=""></path><path class="cls-2" d="M57.76,116.69l-.15,.9c-1.37,8.44,5.15,16.11,13.7,16.11h.03" data-v-13454f0d=""></path><path class="cls-2" d="M193.24,116.69l.15,.9c1.37,8.44-5.15,16.11-13.7,16.11h0" data-v-13454f0d=""></path></g></g></svg>
                            <h3 style="margin: 0">Route: ${element.route}</h3>
                            </div>
                            <h3 style="text-align: left; margin-bottom: 2.5px; margin-top: 2.5px;">Stop #: ${element.stop}</h3>
                            <p style="text-align: left; margin: 0;">Arrival Time: ${element.arrival}</p>
                            <p style="text-align: left; margin: 0;">Departure Time: ${element.departure}</p>
                            <div style="
                            max-height: 100px;
                            overflow-y: scroll;
                            text-align: left;
                            ">
                            ${shipmentInfo}
                            </div>
                            `
                    );

                    //stopType
                    //0 = Order (delivery or pickup)
                    //1 = Depot
                    //2 = Break
                    //isDelivery indicates if stop is pickup or delivery
                    //Priority is some comparison of time windows
                    let markerColor;
                    let inProgress = "#fee354";
                    let completed = "#33f18a";
                    let incomplete = "#ff5534";
                    let waiting = "#32ccfe";
                    // let breakColor = "#000000";
                    //let serviceIncompleteColor = "#fff"

                    // if(element.isDelivery == true && element.stopType == 0){
                    //     markerColor = deliveryColor;
                    // }else if(element.isDelivery == false && element.stopType == 0){
                    //     markerColor = pickupColor;
                    // }else if(element.stopType == 1){
                    //     markerColor = depotColor;
                    // }else if(element.stopType == 2){
                    //     markerColor = breakColor;
                    // }

                    if(element?.serviceIncomplete){
                        console.log("SERVICE INCOMPLETE: ", element)
                        markerColor = incomplete;
                    }else if(element?.serviceCompleted){
                        markerColor = completed;
                    }else if(element?.serviceInProgress){
                        markerColor = inProgress;
                    }else{
                        markerColor = waiting;
                    }

                    console.log(markerColor)

                    // console.log("BREAK TYPE ", element)

                    if(!element.stop){
                        continue;
                    }

                    const svgString = `
                    <svg xmlns="http://www.w3.org/2000/svg" overflow="visible" width="25" height="36" viewBox="0 0 24 32">
                    <g transform="translate(1.75, 28.0)" fill="#000000"><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="10.5" ry="5.25002273"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="10.5" ry="5.25002273"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="9.5" ry="4.77275007"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="8.5" ry="4.29549936"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="7.5" ry="3.81822308"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="6.5" ry="3.34094679"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="5.5" ry="2.86367051"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="4.5" ry="2.38636864"></ellipse></g>
                    <path stroke="#000" stroke-width="1" fill="${markerColor}" d="M12,0c-6.6,0-12,5.4-12,12c0,10,12,20,12,20s12-10,12-20C24,5.4,18.6,0,12,0z M12,15c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S13.7,15,12,15z"/>
                    <circle stroke="${markerColor}" stroke-width="1" cx="12" cy="12" r="10.5" fill="${markerColor}"/>
                    <text x="50%" y="45%" text-anchor="middle" fill="#000" font-size="12" dy=".3em" font-weight = "bold">${element.stop}</text>
                    </svg>
                    `;

                    // Create a new div element and set its innerHTML to the SVG string
                    const svgElement = document.createElement('div');
                    svgElement.innerHTML = svgString;
                    
                    let mapMarker = 
                    new maplibregl.Marker({
                        color: markerColor,
                       element: svgElement
                    }).setLngLat([element.longitude, element.latitude])
                    .setPopup(popup)
                    .addTo(map);

                    markerArray.push(mapMarker)
                }
                console.log("Marker Array: ", markerArray)

                const bounds = new maplibregl.LngLatBounds();

                for (const m of markerArray) {
                    const { lng, lat } = m.getLngLat();
                    bounds.extend([lng, lat]);
                }

                // 2) Guard single-marker case
                if (markerArray.length === 1) {
                    map.easeTo({ center: bounds.getCenter(), zoom: 14 });
                    } else if (!bounds.isEmpty()) {
                    // 3) If you have side panels or a bottom bar, pad appropriately
                    map.resize(); // if the container just changed size
                    map.setPitch(0); // optional: flatten to get a tighter fit
                    map.setBearing(0); // optional
                    map.fitBounds(bounds, {
                        padding: { top: 60, right: 60, bottom: 120, left: 60 },
                        maxZoom: 15,   // prevents zooming in too tight
                        duration: 0    // instant; or use 500 for animation
                    });
                }

                map.addControl(new maplibregl.NavigationControl());
            },
            transformRequest: function (url, resourceType) {
                if (resourceType === 'Style' && !url.includes('://')) {
                    url = `https://maps.geo.${AWS.aws_project_region}.amazonaws.com/maps/v0/maps/${url}/style-descriptor`
                }
                if (url.includes('amazonaws.com')) {
                    return {
                        url: Signer.signUrl(url, {
                            access_key: this.credentials.accessKeyId,
                            secret_key: this.credentials.secretAccessKey,
                            session_token: this.credentials.sessionToken,
                        }),
                    }
                }
                return { url }
            },
            async listRouteData(){
                let graphqlQuery = `query listRoutes{
                    listRoutes(limit: 300){
                        items{
                            routeCode
                            }
                        }
                    }`
                
                try{
                    let listRouteDataReturn = await API.graphql({
                    query:  graphqlQuery,
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                    })
                    
                    this.routeTableData = listRouteDataReturn.data.listRoutes.items;
                }catch(e){
                    console.log(e)
                    if(e){
                        this.toggleAlertBox = true;
                        this.alertMessage = "Error getting route codes"
                    }
                }
            }
    }
}
</script>

<style scoped>
/* @import 'node_modules/maplibre-gl/dist/maplibre-gl.css'; */
body { margin: 0; }
#map { 
    height: 60vh; 
    border-radius: 25px;
}

select{
    padding: 10px;
    font-size: 15px;
    border: 1px solid rgba(0,0,0,.336);
    border-radius: 15px;
    outline: none;
    margin-top: 5px;
    margin-bottom: 5px;
}

.svg-container-outer{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}

.svg-container{
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    width: fit-content;

    background-color: #fff;
    padding: 15px;
    border-radius: 25px;
    margin: 10px;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}

.svg-container h3{
    margin: 0;
}

.svg-inner-container{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    max-width: 200px;
}

.svg-inner-container p{
    margin: 0;
}

.svg-inner-container svg{
    margin-left: 5px;
}

.route-info{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: fit-content;
    background-color: #fff;
    padding: 15px;
    border-radius: 25px;
    flex-basis: 25%;
    margin: 10px;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}

.manifest-header{
    text-align: left;
    background-color: #e4e4e4;
    width: fit-content;
    padding: 5px;
    border-radius: 999px;
    /* margin-bottom: 5px !important; */
    /* margin-top: 0; */
 }

 .print-button{
    background-color: #e4e4e4;
    color: #000;
    border: none;
    border-radius: 999px;
    padding: 5px 15px;
    width: fit-content;
    height: fit-content;
    margin-left: 25px;
    /* margin-top: 5px; */
    margin-bottom: 5px;
    transition-duration: .5s;
    cursor: pointer;
}

.print-button:hover{
    transition-duration: .5s;
    background-color: #d5d5d5;
}

.refresh-button{
    margin-right: 5px;
    background-color: #32ccfe;
    border: none;
    padding: 5px;
    border-radius: 99px;
    color: white;
    transition-duration: .25s;
    cursor: pointer;
}

.refresh-button:hover{
    transition-duration: .25s;
    filter: brightness(0.95);
}

.optimize-manifest-button{
    background-color: #fe804d;
    margin-left: 15px;
    border: none;
    padding: 5px;
    border-radius: 99px;
    color: white;
    transition-duration: .25s;
    cursor: pointer;
}

.optimize-manifest-button:hover{
    transition-duration: .25s;
    filter: brightness(0.95);
}

.update-shipment{
    background-color: #32ccfe;
    border: none;
    padding: 5px;
    border-radius: 99px;
    color: white;
}

.despatch-info-container{
    background-color: #fff;
    padding: 15px;
    border-radius: 25px;
    flex-basis: 25%;
    margin: 10px;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.manifest-text-container{
    display: flex;
    justify-content: flex-start;
 }

 .manifest-text-container h3{
    margin-top: 5px;
    margin-bottom: 5px;
    background-color: #e4e4e4;
    padding: 5px;
    border-radius: 999px;
 }

 .manifest-text-container p{
    margin-top: 5px;
    margin-bottom: 5px;
 }

.alert-container{
        width: 100%;
        height: 100vh;
        display: flex;
        justify-content: center;
        position: absolute;
        z-index: 99;
        left: 0;
        right: 0;
        top: 0;
        background: linear-gradient(rgba(0, 0, 0, 0.15) 0%, rgba(0, 0, 0, 0.15) 90%, rgba(236, 236, 236, 0.05) 100%);
    }

    .inner-container{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
    }

    .main-button-blue-white{
        margin: 5px;
        padding-top: 4px;
        padding-bottom: 4px;
    }

    .text-container{
        background-color: #fff;
        box-shadow: 0 0 20px rgba(0, 0, 0, 0.475);
        border-radius: 15px;
        width: 30%;
        z-index: 99;
        text-align: center;
        position: absolute;
        top: 15%;
        animation: animate-alert .5s ease;
        max-height: 70vh;
        overflow-y: auto;

    }

    .header-container{
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        background-color: #e4e4e4;
        border-radius: 999px;
        padding: 5px;
        width: -moz-fit-content;
        width: fit-content;
        text-align: center;
    }

    .header-outer-container{
        width: 100%;
        display: flex;
        justify-content: center;
        margin-top: 5px;
    }

    .cancel-button{
        margin: 5px;
        background-color: #fe804d;
        color: #fff;
        border-radius: 15px;
        padding: 5px 10px;
        border: none;
        cursor: pointer;
        transition-duration: .25s;
    }

    .cancel-button:hover{
        background-color: #d26a41;
        transition-duration: .25s;
    }

    @keyframes animate-alert {
        from{
            top: 10%;
            opacity: 0;
        }
        to{
            top: 15%;
            opacity: 1;
        }
    }

    @media screen and (max-width: 1000px) {
        .text-container{
            width: 70%;
        }
    }
</style>